// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__lU+2b","clubName":"styles_clubName__skaTm"};